<script setup lang="ts">
    import {defineProps, ref, watch} from "vue";
    import {CloudanoryCmsObject} from "@songfinch/shared/types/cloudinary";

    export type imageFormat = {
        transformation: [{width?: number, crop?: string}]
    }

    type Props = {
        image: CloudanoryCmsObject,
        imagesFormat?: imageFormat,
        alt: string
    }
    const props = defineProps<Props>();

    const img = ref<unknown>();
    watch(
        props.image,
        val => img.value = val,
        {immediate: true}
    );
</script>

<template>
    <img
        class="@aspect-square @rounded-full @object-cover"
        loading="lazy"
        :src="$cld.url(img, props.imagesFormat)"
        :alt="props.alt"
        @error="img = $defaultImage"
    >
</template>
